import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface TransitProps {
  id: string;
  reason: string;
}

export const useInvalidateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, reason }: TransitProps) => {
      const result = await apiClient.transit.invalidateTransit.mutation({ body: { transitId: id, reason } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      queryClient.invalidateQueries({ queryKey: ['transit', variables.id] });
      toast.success(`Invalidation request was sent!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the invalidation request!`);
    },
  });
};
